// extracted by mini-css-extract-plugin
export default {"container":"layoffAllAround_container__6dF+l","heading":"layoffAllAround_heading__-1eSG","subHeading":"layoffAllAround_subHeading__WuslP","cta":"layoffAllAround_cta__MyccB"};